import axios from 'axios';

export default {
    methods: {
        createUsersListBool() {
            this.$store.state.usersListBool = [];
            this.$store.state.usersList.forEach((value) => {
                if(value.ADMIN == "0") {
                    value.ADMIN = false;
                } else {
                    value.ADMIN = true;
                }
                this.$store.state.usersListBool.push(value);
            });
        },
        storeMessagesProject() {
            this.$store.state.SolarToolMessages.forEach((value) => {
                switch(value.importance) {
                    case "avertissement":
                        this.$store.state.SolarToolMessagesAvertissement.push(value.message);
                        this.$store.state.dmr = this.$store.state.SolarToolMessagesAvertissement.length;
                        break;
                    case "erreur":
                        this.$store.state.SolarToolMessagesErreur.push(value.message);
                        break;
                    case "resultat":
                        this.$store.state.SolarToolMessagesResultat.push(value.message);
                        break;
                }
            });
        },
        getCustomerList() {           
            var link = this.$store.state.serverLink + "/rexelmultienergy1/customersList.php";
            axios.get(link, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            }).then(response => {
                this.$store.state.SolarToolCustomersList = response.data;
            })
            .catch(function(){
            });
        },
        searchCustomer() {         
            this.$store.state.SolarToolSearchCustomerNumberInProgress = true;
            const formData = new FormData();
            formData.append('NUM_CLIENT', this.$store.state.SolarToolCustomerNumber);
            formData.append('SOCIETE', this.$store.state.customer.SOCIETE);
            formData.append('RUE', this.$store.state.customer.RUE);
            formData.append('CP', this.$store.state.customer.CP);
            formData.append('LOCALITE', this.$store.state.customer.LOCALITE);
            formData.append('TVA', this.$store.state.customer.TVA);
            
            var link = this.$store.state.serverLink + "/rexelmultienergy1/searchCustomer.php";
            axios.post(link, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            }).then(response => {
                this.$store.state.SolarToolCustomerName = null;
                this.$store.state.SolarToolFoundCustomers = response.data;
                this.$store.state.SolarToolSearchCustomerNumber = false;
                this.$store.state.SolarToolSearchCustomerNumberInProgress = false;
            })
            .catch(function(){
            });
        },
        solarToolResults() {
            const formData = new FormData();
            formData.append('savepath', "files/data/");
            formData.append('netstoresession', this.$store.state.SolarToolNetstoreSession);
            formData.append('customernumber', this.$store.state.SolarToolCustomerNumber);
            formData.append('sessionid', this.$store.state.SolarToolSessionId);            
            formData.append('uploadDirectory', this.$store.state.SolarToolDirectory);
            formData.append('useralias', this.$store.state.SolarToolUserAlias);
            this.$store.state.SolarToolMessagesAvertissement = [];
            this.$store.state.SolarToolMessagesErreur = [];
            this.$store.state.SolarToolMessagesResultat = [];
            
            var link = this.$store.state.serverLink + "/rexelmultienergy1/smasogvue.php";
            axios.post(link, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            }).then(response => {
                this.$store.state.SolarToolAswJson = response.data.offre;
                this.$store.state.SolarToolMessages = response.data.messages;
                this.$store.state.SolarToolDonneesProjet = response.data.projet;
                this.$store.state.pageSolarToolResultsActive = true;
                if(this.$store.state.SolarToolAswJson.details.length > 0) {
                    this.$store.state.pageSolarToolResultsActive = true;
                }
                this.storeMessagesProject();
                this.analyseChipTexts();
            })
            .catch(function(){
            });
        },
        sendToNetstore() {
            const formData = new FormData();
            this.$store.state.SolarToolAswJson.reference = this.$store.state.SolarToolNomProjet.Nom;
            formData.append('json_quotation', JSON.stringify(this.$store.state.SolarToolAswJson));
            formData.append('netstore_session', this.$store.state.SolarToolNetstoreSession);
            formData.append('customer_number', this.$store.state.SolarToolCustomerNumber);
            formData.append('session_id', this.$store.state.SolarToolSessionId);
            formData.append('user_alias', this.$store.state.SolarToolUserAlias);
            formData.append('project_directory', this.$store.state.SolarToolDirectory);
            formData.append('project_name', this.$store.state.SolarToolNomProjet.Nom);
            formData.append('project_street', this.$store.state.SolarToolNomProjet.Rue);
            formData.append('project_cp', this.$store.state.SolarToolNomProjet.Cp);
            formData.append('project_city', this.$store.state.SolarToolNomProjet.Localite);
            formData.append('project_country', this.$store.state.SolarToolNomProjet.Pays);
            formData.append('project_esdec_link', this.$store.state.SolarToolEsdecLink);

            var link = this.$store.state.serverLink + "/rexelmultienergy1/netstorevue.php";
            axios.post(link, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            }).then(response => {
                this.$store.state.SolarToolMessagesAvertissement = [];
                this.$store.state.SolarToolMessagesResultat = [];
                this.$store.state.SolarToolMessagesErreur = [];
                this.$store.state.SolarToolMessages = response.data.messages;
                this.$store.state.SolarToolMessages.forEach((item) => {
                    if(item.importance == "avertissement") {
                        this.$store.state.SolarToolMessagesAvertissement.push(item.message);
                    }
                    if(item.importance == "resultat") {
                        this.$store.state.SolarToolMessagesResultat.push(item.message);
                        this.$store.state.SolarToolOpenDialogResult = true;
                        this.$store.state.SolarToolquotationNumber = item.quotationNumber;
                    }
                    if(item.importance == "erreur") {
                        this.$store.state.SolarToolMessagesErreur.push(item.message);
                    }
                });
                this.analyseChipTexts();
            })
            .catch(function(){
            });
        },
        analyseChipTexts() {
            if(this.$store.state.SolarToolMessagesErreur.length > 1) {
                this.$store.state.SolarToolMessagesErreurText = this.$store.state.SolarToolMessagesErreur.length + " erreurs";
            } else {
                this.$store.state.SolarToolMessagesErreurText = this.$store.state.SolarToolMessagesErreur.length + " erreur";
            }
            if(this.$store.state.SolarToolMessagesAvertissement.length > 1) {
                this.$store.state.SolarToolMessagesAvertissementText = this.$store.state.SolarToolMessagesAvertissement.length + " avertissements";
            } else {
                this.$store.state.SolarToolMessagesAvertissementText = this.$store.state.SolarToolMessagesAvertissement.length + " avertissement";
            }    
        },
        solarToolResetData(resetNetstoreId) {
            this.$store.state.pageSolarToolMainActive = false;
            this.$store.state.pageSolarToolResultsActive = false;
            this.$store.state.SolarToolUploadedFilesNumber = 0;
            this.$store.state.SolarToolIsUploading = false;
            this.$store.state.SolarToolEsdecLink = "";
            this.$store.state.SolarToolIsCifCSV = false;
            this.$store.state.SolarToolMessagesAvertissement = null;
            this.$store.state.SolarToolMessagesErreur = null;
            this.$store.state.SolarToolMessagesResultat = null;
            this.$store.state.SolarToolAswJson = null;  
            this.$store.state.SolarToolNomProjet.Cp = "";              
            this.$store.state.SolarToolNomProjet.Localite = "";              
            this.$store.state.SolarToolNomProjet.Nom = "";             
            this.$store.state.SolarToolNomProjet.Pays = "";              
            this.$store.state.SolarToolNomProjet.Rue = ""; 
            this.$store.state.SolarToolDonneesProjet = null;
            this.$store.state.uploadResponse = null;
            this.$store.state.SolarToolMessagesAvertissementText = "";
            this.$store.state.SolarToolMessagesErreur = "";
            this.$store.state.SolarToolCustomerNumber = "";
            this.$store.state.SolarToolCustomerNumberIsValid = false;
            this.$store.state.SolarToolCustomerNumberIsInvalid = true;
            //this.$store.state.SolarToolSessionId = "";
            if(resetNetstoreId) {
                this.$store.state.SolarToolNetstoreSession = "";
            }
        },
        SolarToolSubmitFiles() {
            const formData = new FormData();
            for (var i = 0; i < this.$refs.SolarToolUploadFiles.files.length; i++ ){
                let file = this.$refs.SolarToolUploadFiles.files[i];
                formData.append('files[' + i + ']', file);
                formData.append('netstoresession', this.$store.state.SolarToolNetstoreSession);
                formData.append('customerNumber', this.$store.state.SolarToolCustomerNumber);
                formData.append('projectName', this.$store.state.SolarToolNomProjet);
                formData.append('sessionId', this.$store.state.SolarToolSessionId);
                formData.append('userAlias', this.$store.state.SolarToolUserAlias);
            }
            this.$store.state.SolarToolIsUploading = true;
            var link = this.$store.state.serverLink + "/rexelmultienergy1/uploadvue.php";
            axios.post(link, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            }).then(response => {
                this.$store.state.SolarToolIsUploading = response.data.uploading;
                this.$store.state.SolarToolIsUploaded = response.data.uploaded;
                this.$store.state.SolarToolIsCifCSV = response.data.iscifcsv;
                this.$store.state.uploadResponse = response.data;
                this.$store.state.SolarToolDirectory = response.data.directory;
                this.solarToolResults();
            })
            .catch(function(){
            });
        },

    }
};
